import { useQuery } from 'react-query';

import { getMiceToTrapAmountChartData } from 'api/analitics/MCTCharts/4_getMiceToTrapAmount';
import { TrapType } from 'components/AnalyticsPage/TrapType';

export const useGetMiceToTrapAmountChartData = (
  slug: string,
  period: string,
  trapType: TrapType,
  startDate: string,
  endDate: string,
  enabled?: boolean,
) => {
  const { data, refetch, isLoading, isFetching } = useQuery(
    'MiceToTrapAmountChartData',
    () => getMiceToTrapAmountChartData(slug, period, trapType, startDate, endDate),
    {
      refetchOnWindowFocus: false,
      enabled,
    },
  );

  return { data, refetch, isLoading, isFetching };
};

export default useGetMiceToTrapAmountChartData;
